module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"a":"Langues"},"en":{"a":"Languages"}}')
  delete Component.options._Ctor
}
